// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"_2iDkf8","disabled":"_2uGXy_","control":"_30VH1S","control-indicator":"_24_Dny","partial":"_56X1Lv","large":"_1dKMBS","lazy-rendered":"YDPO7G","labelctn":"_3879cV"};